import { icons } from "assets/icons";
import React from "react";
import { colours } from "styling/colours";
import { style } from "typestyle";

export const CalendarIcon = () => {
  return <icons.TaskSchedulerIcon aria-label="Calendar" className={calendarIconStyle} />;
};

const calendarIconStyle = style({
  width: "18px",
  fill: colours.secondaryText,
  height: "18px",
  marginLeft: "10px",
  marginRight: "3px",
});
